export default "__VITE_ASSET__CS7sauUp__"